import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../../api-entry-control.service';

export function atLeastOneDaySelectedValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const days = control.get('days')?.value as string[];
    if (days && days.length > 0) {
      return null; // La validación pasa si al menos un día está seleccionado
    } else {
      return { atLeastOneDaySelected: true }; // La validación falla si ningún día está seleccionado
    }
  };
}

@Component({
  selector: 'app-add-employees',
  templateUrl: './add-employees.component.html',
  styleUrls: ['./add-employees.component.css']
})
export class AddEmployeesComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  ngOnInit(): void {
    this.form1.patchValue({
      xdays: this.allDays
    });
    if (this.storesId > 0) {
      this.form1.get('stores_id')?.setValue(this.storesId);
    }
  }

  @Output()
  success = new EventEmitter<boolean>();

  @Input()
  storesId: number;

  allDays: string[] = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  form1: FormGroup = this.formBuilder.group({
    id:[],
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    email: [''],
    phone: [''],
    state_id:[0],
    stores_id: [0],
    days: [''],
    xdays: [[]]
  }, { validators: atLeastOneDaySelectedValidator() });
  create() {
    const selectedDays = this.form1.value.xdays as string[];
    const daysString = selectedDays ? selectedDays.join(',') : '';

    this.form1?.get('days')?.setValue(daysString);

    this.api.createEmployees(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'Registro de participante');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }



  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1.get('rut')?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
  toggleDaySelection(day: string): void {
    const xdaysControl = this.form1.get('xdays');
    const currentValue = [...(xdaysControl.value || [])]; // Crea una copia
  
    const selectedIndex = currentValue.indexOf(day);
  
    if (selectedIndex === -1) {
      // Si el día no está seleccionado, agrégalo
      currentValue.push(day);
    } else {
      // Si el día está seleccionado, retíralo
      currentValue.splice(selectedIndex, 1);
    }
  
    xdaysControl.setValue(currentValue);
  }
  
}
